import styled from "styled-components";
import Card from "@mui/material/Card";

export const Container = styled(Card)`
    padding: 5px;
    width: min(1000px, 95vw);
    max-width: 1000px;
    max-height: 800px;
    overflow: auto;
    color: #000000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #f5f5f5;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 20px;
`;
